import { useEffect } from "react";

import { startVisualViewportHeightSync } from "@/lib/visualViewportHeight";

/** Mobile keyboard handling for full-height form flows. */
export function VisualViewportHeightSync(): null {
  useEffect(() => startVisualViewportHeightSync(), []);
  return null;
}
